import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, checked } = useAuth();
    if (!checked || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[var(--navy)]">
                <div className="label-mono text-[var(--gold)] animate-pulse">AUTHENTICATING…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}
